<template>
    <main>
        <input  :disabled="disabled" v-model="val"  type="text" class="form-control">
    </main>
</template>
<script>
export default {
    props: ['antecedente','value','validado'],
    data () {
        return{
            val:this.value,
        }
    },
    watch:{
        val:function(){
            this.$emit('input',this.val);
        }
    },
    computed:{
        disabled:function(){
            if(this.validado===1){
                return true;
            }
            return false
        }
    }
}
</script>


